require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./research-tipswhenapplying.json") })
        }
      }, "path---research-tipswhenapplying");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---research-tipswhenapplying!./.cache/json/research-tipswhenapplying.json
// module id = 440
// module chunks = 231608221292675